@let imageData = imageData$ | async;

<!-- Instances of expired images still populating the json can cause issues,
  imageData.responsiveImageLinksData checker is used to verify the validity of the image (as expired image objects do not include it). -->
@if (imageData && !imageData.error && imageData.responsiveImageLinksData) {
  <fcom-lqip-image
    class="fill"
    [fillParent]="fillParent"
    [imageData]="imageData"
    [alt]="imageData.alt"
    [ratio]="aspectRatio$ | async"
    [scale]="scale"
    [maxWidth]="maxImageWidth"
    [fetchPriority]="fetchPriority"
    [loading]="isLazyLoad ? ImgLoading.LAZY : ImgLoading.EAGER"
    [decoding]="isLazyLoad ? ImgDecoding.ASYNC : ImgDecoding.SYNC"
    [enableLqip]="enableLqip"
  />
}
